import { useCallback } from 'react';
import { SERVER_ROUTES } from 'b2b-apps/shop/routes/components/Router/routes';
import { useRouterUrl } from 'b2b-apps/shop/routes/hooks';

export type UseLoginUrlType = (reason?: string) => string;

export const useLoginUrl = (): UseLoginUrlType => {
  const fullLocation = useRouterUrl();

  return useCallback(
    () => `${SERVER_ROUTES.login}?backTo=${encodeURIComponent(fullLocation)}`,
    [fullLocation],
  );
};
